import React from 'react'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

function NoAccessPage(){
    const { t } = useTranslation();
    return(
        <Alert variant='danger' className="m-3">
            {t('components.noaccesspage')}
        </Alert>
    )
}
export default NoAccessPage;